import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=20a35fbe&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=20a35fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a35fbe",
  null
  
)

export default component.exports